<style lang="less" scoped>
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 270px;
  }
  .title {
    text-align: cetner;
    font-size: 27px;
    color: #7965ef;
    line-height: 180%;
  }
  .description {
    font-size: 19px;
    margin-top: 16px;
    color: #303030;
  }
  .footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
    border: 1px solid #e3e3e3;
    background-color: #f7f7f7;
  }
  .account-info {
    font-size: 20px;
  }
  .highlight {
    color: #ff6c00;
  }
  .footer-paragraph {
    font-size: 13px;
    margin-top: 10px;
    &:first-of-type {
      margin-top: 40px;
    }
  }
  footer.footer {
    border-radius: 5px;
  }
</style>

<template lang="pug">
  .review-container
    section.content
      h1.title 입점 승인 되었습니다.
      p.description 상품 셋팅 비용 결제가 완료되면 쇼핑몰 / 상품이 노출됩니다. (영업일 기준 1~2일 소요)
    footer.footer
      h2.account-info 결제정보 : #[span.highlight 국민은행 464837-01-007268 (주) 스타일닷컴]
      p.footer-paragraph 33만원은 상품 수집 셋팅 비용이며, 셋팅 완료 후엔 환불되지 않습니다.
      p.footer-paragraph 등록 후 운영이 안되거나 판매에 문제가 있는 경우 미노출 처리될 수 있습니다.
      p.footer-paragraph 고객센터 : 02-3442-3555
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    if (localStorage.token === undefined) {
      return next('/login');
    }
    return next();
  },
};
</script>
